import { createContext, useCallback, useContext, useState } from "react";
import { TransactionDetails } from "@areas";

const TransactionDrawerContext = createContext(null);

export const useTransactionDrawer = () =>
  useContext(TransactionDrawerContext) ?? { openTransaction: () => {} };

// Mounts the transaction detail drawer once, app-wide, so anything (e.g. a POS-payment
// notification) can open a payment's detail over the current page instead of navigating to the
// transactions list.
export function TransactionDrawerProvider({ children }) {
  const [transaction, setTransaction] = useState(null);

  const openTransaction = useCallback(
    (paymentId, paymentMethodKey) => setTransaction({ paymentId, paymentMethodKey }),
    [],
  );

  return (
    <TransactionDrawerContext.Provider value={{ openTransaction }}>
      {children}
      <TransactionDetails
        id={transaction?.paymentId}
        paymentMethodKey={transaction?.paymentMethodKey}
        onClose={() => setTransaction(null)}
        onChange={() => {}}
      />
    </TransactionDrawerContext.Provider>
  );
}
